import React, { useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CustomerEntry } from "../apiClient/ApiClient";
import { useStore } from "../Store";

const CustomerEntryRoute = ({ entry, entryKey }: {
  entry: CustomerEntry | null;
  entryKey: string;
}) => {
  const { casesStore } = useStore();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    window.history.replaceState(window.history.state, "", "/app");
  }, [entryKey]);

  useEffect(() => {
    let active = true;
    let finished = false;

    if (!entry) {
      casesStore.invalidateSession();
      navigate("/invalid-link", { replace: true });
      return;
    }

    void casesStore.openLink(entry).then(success => {
      if (!active) return;
      finished = true;
      navigate(success ? "/app" : "/invalid-link", { replace: true });
    });

    return () => {
      active = false;
      if (!finished) casesStore.invalidateSession();
    };
    // entryKey identifies the URL being exchanged, not an internal case group.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryKey, casesStore, navigate]);

  return <div className="loading-dots" aria-label="Loading case">
    <span className="dot" /><span className="dot" /><span className="dot" />
  </div>;
};

export default CustomerEntryRoute;
